import { render, staticRenderFns } from "./ModalDetalleSaldos.vue?vue&type=template&id=2603cc92&"
import script from "./ModalDetalleSaldos.vue?vue&type=script&lang=js&"
export * from "./ModalDetalleSaldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports